import groq from 'groq';

import { ASSET, CLOUDINARY_VIDEO } from '../common';

export const SEE_IT_IN_ACTION = groq`
  seeItInAction {
    title,
    items[]-> {
      handle,
      url,
      "video": { ${CLOUDINARY_VIDEO} },
      poster { ${ASSET} }
    }
  }
`;
